<template>
    <DsToast class="md:top-0" />

    <h3 class="my-4">Auto-dismiss (8 seconds)</h3>
    <div class="flex flex-col gap-3">
        <div>
            <DsButton
                size="sm"
                variant="secondary"
                @click="showToast('info')"
            >
                Show info
            </DsButton>
        </div>
        <div>
            <DsButton
                size="sm"
                variant="secondary"
                @click="showToast('error')"
            >
                Show error
            </DsButton>
        </div>
    </div>

    <h3 class="my-4">Persistent (dismiss manually)</h3>
    <div class="flex flex-col gap-3">
        <div>
            <DsButton
                size="sm"
                variant="secondary"
                @click="showPersistentToast('info')"
            >
                Show persistent info
            </DsButton>
        </div>
        <div>
            <DsButton
                size="sm"
                variant="secondary"
                @click="showPersistentToast('error')"
            >
                Show persistent error
            </DsButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import DsButton from '@/components/design-system/button/DsButton.vue';
import DsToast from '@/components/design-system/toast/DsToast.vue';
import useDsToast from '@/components/design-system/toast/useDsToast';
import { ref } from 'vue';

const { addToast } = useDsToast();

const messages = [
    `I must go down to the seas again`,
    `to the lonely sea and the sky`,
    `And all I ask is a tall ship`,
    `and a star to steer her by;`,
    `And the wheel's kick and the wind's song`,
    `and the white sail's shaking`,
    `And a grey mist on the sea's face`,
    `and a grey dawn breaking.`,
];
const lastMessageIndex = ref(-1);

const showToast = (severity: 'info' | 'error') => {
    const nextIndex = lastMessageIndex.value < 0 ? 0 : lastMessageIndex.value + 1;
    const messageIndex = messages[nextIndex] ? nextIndex : 0;
    addToast({
        severity,
        detail: messages[messageIndex],
    });
    lastMessageIndex.value = messageIndex;
};

const showPersistentToast = (severity: 'info' | 'error') => {
    addToast({
        severity,
        detail: severity === 'error' ? 'This error stays until dismissed.' : 'This notice stays until dismissed.',
        persistent: true,
    });
};
</script>
